import { metricasApi } from "../hooks/metricasApi";
import { DadosDashboard } from "../types/Metricas";
import moment from "moment";

interface LoadMetricasParams {
  dataInicio?: string;
  dataFim?: string;
  idUsuario?: string;
}

interface LoadMetricasCallbacks {
  onResumoLoaded: (dados: Partial<DadosDashboard>) => void;
  onVisitantesLoaded: (dados: Partial<DadosDashboard>) => void;
  onPedidosLoaded: (dados: Partial<DadosDashboard>) => void;
  onCupomLoaded: (dados: Partial<DadosDashboard>) => void;
  onEstadosLoaded: (dados: Partial<DadosDashboard>) => void;
  onError: (error: any, tipo: string) => void;
}

export const carregarMetricas = async (
  params: LoadMetricasParams,
  callbacks: LoadMetricasCallbacks
) => {
  const api = metricasApi();

  const dataInicioFinal = params.dataInicio || moment().subtract(7, "days").format("YYYY-MM-DD");
  const dataFimFinal = params.dataFim || moment().format("YYYY-MM-DD");

  const requestParams: any = {
    data_inicio: dataInicioFinal,
    data_fim: dataFimFinal
  };

  // Só incluir id_usuario se for uma string não vazia e diferente de "todos"
  if (params.idUsuario && params.idUsuario.trim() !== '' && params.idUsuario !== 'todos') {
    requestParams.id_usuario = params.idUsuario;
  }

  // Buscar cada métrica independentemente dos endpoints modulares
  const promises = [
    api.getResumo(requestParams)
      .then(dados => {
        callbacks.onResumoLoaded(dados);
      })
      .catch(error => {
        callbacks.onError(error, 'resumo');
      }),

    api.getHistoricoVisitantes(requestParams)
      .then(dados => {
        callbacks.onVisitantesLoaded(dados);
      })
      .catch(error => {
        callbacks.onError(error, 'visitantes');
      }),

    api.getHistoricoPedidos(requestParams)
      .then(dados => {
        callbacks.onPedidosLoaded(dados);
      })
      .catch(error => {
        callbacks.onError(error, 'pedidos');
      }),

    api.getHistoricoCupom(requestParams)
      .then(dados => {
        callbacks.onCupomLoaded(dados);
      })
      .catch(error => {
        callbacks.onError(error, 'cupom');
      }),

    api.getHistoricoEstados(requestParams)
      .then(dados => {
        callbacks.onEstadosLoaded(dados);
      })
      .catch(error => {
        callbacks.onError(error, 'estados');
      })
  ];

  await Promise.allSettled(promises);
};
